/* RESPONSIBLE TEAM: team-fin-voice */

export type Provider = 'intercom' | 'external';
export type IncomingType = 'pstn' | 'sip';
export type ProvisioningStep = 'provider-selection' | 'line-config' | 'intercom-provisioning';

export const PROVISIONING_STEPS = {
  PROVIDER_SELECTION: 'provider-selection',
  LINE_CONFIG: 'line-config',
  INTERCOM_PROVISIONING: 'intercom-provisioning',
} as const;

export const PROVIDERS = {
  INTERCOM: 'intercom',
  EXTERNAL: 'external',
} as const;

export const INCOMING_TYPES = {
  PSTN: 'pstn',
  SIP: 'sip',
} as const;
